import { Controller } from "stimulus";
import Splide from "@splidejs/splide";

// or only core styles
import "@splidejs/splide/css/core";

export default class extends Controller {
  static targets = ["main", "thumbs"];

  initialize() {
    console.log("Carousel Initialised");

    if (this.hasMainTarget) {
      this.mainSlider = new Splide(this.mainTarget, {
        perPage: 1,
        pagination: false,
        arrows: true,
        type: "loop",
      });
    }

    if (this.hasMainTarget && this.hasThumbsTarget) {
      this.thumbsSlider = new Splide(this.thumbsTarget, {
        isNavigation: true,
        pagination: false,
        arrows: false,
        rewind: true,
        gap: 20,
        type: "loop",
        perPage: 3,
        fixedWidth: "27%",
      });
    }

    if (this.thumbsSlider) {
      this.mainSlider.sync(this.thumbsSlider);
      this.mainSlider.mount();
      this.thumbsSlider.mount();
    } else {
      this.mainSlider.mount();
    }
  }
}
